export const all = (...args: any[]) =>
  args.every(v => Boolean(v) && v !== 'undefined');

export const any = (...args: any[]) =>
  args.some(v => Boolean(v) && v !== 'undefined');

export const isDefined = <T>(input: T | undefined | null): input is T =>
  typeof input !== 'undefined' && input !== null;
